import React from "react";
import { useNavigate } from "react-router-dom";
import Link from "@mui/material/Link";
import { Button, Typography } from "@mui/material";
import { SubModAppImages } from "../../constants/constants";
import "./NotFound.scss"

const { img404 } = SubModAppImages;

const NotfoundPage = () => {
  const navigate = useNavigate();
  const today = new Date();
  const year = today.getFullYear();

  const handlenotfound = () => {
    navigate("/");
  };
  return (
    <>
      <div className="notfound">
        <img className="notfoundimg" alt="not found" src={img404} />
        <Typography className="notfoundcontent">The Page You Requested Could Not Found!</Typography>
        <Button className="notfoundbtn" variant="contained" onClick={handlenotfound}>
          Back
        </Button>
        <footer>
          <p>
            <Link href="/privacy-policy" underline="none" color="#333">
              <b>Privacy Policy</b>
            </Link>
            | Copyright (c) {year} Managed Solution LLC
          </p>
        </footer>
      </div>
    </>
  );
};

export default NotfoundPage;
